import React from 'react'

export const createSettings = newsList => ({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: newsList.length > 2 ? 3 : newsList.length > 1 ? 2 : 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 400,
            settings: {
                dots: true,
                slidesToShow: newsList.length > 1 ? 1.1 : 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                dots: true,
                slidesToShow: newsList.length > 1 ? 1.2 : 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                dots: true,
                centerMode: true,
                slidesToShow: newsList.length > 1 ? 1.4 : 1
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: newsList.length > 2 ? 2.4 : newsList.length > 1 ? 2 : 1
            }
        }
    ],
    appendDots: dots => (
        <div>
            <ul> {dots} </ul>
        </div>
    ),
    customPaging: i => <div className="news-section-slider-dot" />
})
